module.exports = __webpack_public_path__ + "img/P150T_weapon_112.5fe189e2.png";